import { ReactNode } from "react";
import { card, panelHeading } from "../../../styles";

interface Props {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}

/** The `card` + header + right-aligned-actions block repeated across every admin tab. */
export default function SectionCard({ title, actions, children }: Props) {
  return (
    <div style={{ ...card, padding: 0, overflow: "hidden" }}>
      <div style={{ padding: "1.25rem 1.5rem 0.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
        <h2 style={{ ...panelHeading, margin: 0 }}>{title}</h2>
        {actions && <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>{actions}</div>}
      </div>
      {children}
    </div>
  );
}
